angular.module('cfn').controller('fieldGroupCoreController', [
  '$scope',
  '$rootScope',
  'CoreREST',
  'FieldGroup',
  '$http',
  '$timeout',
  '$log',
  '$dialog',
  '$injector',
  '$route',
  'FavoriteService',
  'i18nFilter',
  function(
    $scope,
    $rootScope,
    CoreREST,
    FieldGroup,
    $http,
    $timeout,
    $log,
    $dialog,
    $injector,
    $route,
    FavoriteService,
    i18nFilter
  ) {
    var mode = {
      name: 'fieldGroup',
      hasActive: true
    };

    var ctrl = this;
    ctrl.getEntityName = function() {
      try {
        return $scope.details.fieldGroup.name;
      } catch (e) {
        return '';
      }
    };

    var specialAdd = (mode.specialAdd = []);
    var ele = null;
    ele = {};
    ele.property = 'fields';
    ele.Property = 'Fields';
    specialAdd.push(ele);

    ctrl.addFieldsToGroup = function() {
      return (elements) => {
        ctrl.callRest('addFieldsByIdMultiple/' + $scope.details.fieldGroup.id ) (elements);
      };
    };
    // validation engine
    var vgi = {};
    vgi['active'] = '1';
    vgi['name'] = '1';
    vgi['number'] = '1';
    vgi['fields'] = '1';
    mode.vgi = vgi;

    return coreCommonController(
      'fieldGroup',
      ctrl,
      mode,
      $scope,
      $rootScope,
      CoreREST,
      FieldGroup,
      $http,
      $timeout,
      $log,
      $dialog,
      $injector,
      $route,
      FavoriteService,
      i18nFilter
    );
  }
]);
